import { useUrlBuilder } from '@/composables/url-builder/index.ts'

export function getBooksyWalletUrl (env) {
  const url = env.VUE_APP_BOOKSY_WALLET_URL ?? window.location.origin.replace('://', '://booksy-wallet.')

  return useUrlBuilder(url).removeTrailingSlash().build()
}
